import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ofType } from 'redux-observable';
import { concat, EMPTY, of, race, zip } from 'rxjs';
import { mergeMap, take } from 'rxjs/operators';

import { NotificationService, NOTIFICATION_TYPE_ERROR } from 'ui-components/services/notification-service';
import { Button } from 'ui-components/components/button';

import { startUpdateAvailableShippingServices } from '../csw/csw.actions';
import { GET_REFERENCE_DATA_FAILURE, GET_REFERENCE_DATA_SUCCESS, getReferenceData } from '../reference-data/reference-data.actions';
import * as SellerActions from '../seller/seller.actions';

import * as Actions from './wallet.actions';
import { getAccountInformation } from '../account-information/account-information.actions';

const title = <FormattedMessage defaultMessage='An unexpected error occurred' description='dataRefreshError.title' id='EHyasi' />;

const content = (
  <FormattedMessage
    defaultMessage='Registration was successful but something unexpected occurred while updating the page. <a>Click here to refresh your page.</a>'
    description='Post wallet registration refresh error message'
    id='DDOUzn'
    values={{
      a: (chunks) => (
        <Button onClick={() => window.location.reload()} theme='link'>
          {chunks}
        </Button>
      ),
    }}
  />
);

const updateCswsAvailableShippingServices = (fulfillmentPlanIdsAndShipFromIds) => {
  if (!fulfillmentPlanIdsAndShipFromIds?.length) {
    return EMPTY;
  }

  const shippingServiceActions = fulfillmentPlanIdsAndShipFromIds.map(({ fulfillmentPlanId, shipFromId }) =>
    startUpdateAvailableShippingServices(fulfillmentPlanId, shipFromId),
  );
  return concat(of(...shippingServiceActions));
};

export const postWalletRegistrationSuccess = (action$) => {
  return action$.pipe(
    ofType(Actions.POST_WALLET_REGISTRATION_SUCCESS),
    mergeMap(({ fulfillmentPlanIdsAndShipFromIds }) => {
      return concat(
        of(
          SellerActions.refreshSellerWallets(),
          SellerActions.refreshLabelProviders({ shouldRefreshServices: true }),
          SellerActions.refreshPackagesRequest(),
          getReferenceData(),
          getAccountInformation(false),
        ),
        race(
          zip(
            action$.pipe(ofType(SellerActions.REFRESH_PACKAGES_SUCCESS), take(1)),
            action$.pipe(ofType(SellerActions.REFRESH_SHIPPING_SERVICES_SUCCESS), take(1)),
            action$.pipe(ofType(GET_REFERENCE_DATA_SUCCESS), take(1)),
            action$.pipe(ofType(SellerActions.UPDATE_SELLER_WALLETS), take(1)),
          ).pipe(
            mergeMap(() => {
              return updateCswsAvailableShippingServices(fulfillmentPlanIdsAndShipFromIds);
            }),
          ),
          action$.pipe(
            ofType(
              SellerActions.REFRESH_PACKAGES_FAILURE,
              SellerActions.REFRESH_LABEL_PROVIDERS_FAILURE,
              SellerActions.REFRESH_SHIPPING_SERVICES_FAILURE,
              GET_REFERENCE_DATA_FAILURE,
              SellerActions.REFRESH_SELLER_WALLETS_FAILURE,
            ),
            take(1),
            mergeMap(() => {
              NotificationService.showNotification({
                notificationType: NOTIFICATION_TYPE_ERROR,
                title,
                content,
                dontHide: true,
              });
              return EMPTY;
            }),
          ),
        ),
      );
    }),
  );
};
